// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__Header___x5p6e"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/treasury/payment-partners/components/Header.css
// module id = 1019
// module chunks = 0